import {request} from "./client";

/** Uploads files and returns [{path, url, name}]: save `path` on the listing/project, show `url`.
 * kind: "image" (jpg/png/webp), "document" (pdf or image: brochures, floor plans), "video". */
export const uploadMedia = (files, kind = "image") => {
    const form = new FormData();
    Array.from(files).forEach((f) => form.append("files", f));
    return request(`/broker/media?kind=${kind}`, {method: "POST", body: form});
};
